var swiper = new Swiper(".mySwiper", {
	slidesPerView: 1,
	centeredSlides: false,
	slidesPerGroupSkip: 1,
	spaceBetween: 30,
	grabCursor: true,
	keyboard: {
		enabled: true,
	},
	breakpoints: {
		1200: {
			slidesPerView: 3.5,
			slidesPerGroup: 1,
		},
		992: {
			slidesPerView: 3,
			slidesPerGroup: 1,
		},
		768: {
			slidesPerView: 2.5,
			slidesPerGroup: 1,
		},
		375: {
			slidesPerView: 1.5,
			slidesPerGroup: 1,
		},
		320: {
			slidesPerView: 1,
			slidesPerGroup: 1,
		},
	},
	scrollbar: {
		el: ".swiper-scrollbar",
		draggable: true, // Enables dragging
	},
});


// testimonial slider
var swiper = new Swiper(".mySwiper1", {
slidesPerView: 4,
  slidesToScroll: 1,
	centeredSlides: false,
	spaceBetween: 15,
	speed: 1000,
	grabCursor: true,
	loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
	breakpoints: {
		1200: {
			slidesPerView: 4,
  slidesToScroll: 1,
		},
		992: {
			slidesPerView: 3,
  slidesToScroll: 1,
		},
		768: {
			slidesPerView: 2,
  slidesToScroll: 1,
		},
		320: {
			slidesPerView: 1,
			slidesPerGroup: 1,
		},
	},
});



// comparison slider
var divisor = document.getElementById("divisor"),
    handle = document.getElementById("handle"),
    slider = document.getElementById("slider");

function moveDivisor() {
  handle.style.left = slider.value+"%";
	divisor.style.width = slider.value+"%";
}

window.onload = function() {
	moveDivisor();
};



// video style
const video = document.getElementById("video");
const circlePlayButton = document.getElementById("circle-play-b");

function togglePlay() {
	if (video.paused || video.ended) {
		video.play();
	} else {
		video.pause();
	}
}

circlePlayButton.addEventListener("click", togglePlay);
video.addEventListener("playing", function () {
	circlePlayButton.style.opacity = 0;
});
video.addEventListener("pause", function () {
	circlePlayButton.style.opacity = 1;
});


// card slider

// // Get the modal
// var modal = document.getElementById("myModal");

// // Get the button that opens the modal
// var btn = document.getElementById("myBtn");

// // Get the <span> element that closes the modal
// var span = document.getElementsByClassName("close")[0];

// // When the user clicks the button, open the modal 
// btn.onclick = function() {
//   modal.style.display = "block";
// }

// // When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modal.style.display = "none";
// }

// // When the user clicks anywhere outside of the modal, close it
// window.onclick = function(event) {
//   if (event.target == modal) {
//     modal.style.display = "none";
//   }
// }

// Get all buttons and modals
var buttons = document.querySelectorAll("[data-modal]");
var modals = document.querySelectorAll(".MYmodal");
var spans = document.querySelectorAll(".close");

// Function to close all modals
function closeAllModals() {
  modals.forEach(function(modal) {
    modal.style.display = "none";
  });
}

// Loop through buttons to add click event listeners
buttons.forEach(function(btn) {
  btn.onclick = function() {
    closeAllModals(); // Close all modals before opening a new one
    var modalId = this.getAttribute("data-modal");
    document.getElementById(modalId).style.display = "block";
  };
});

// Loop through span elements to close the respective modal
spans.forEach(function(span) {
  span.onclick = function() {
    var modalId = this.getAttribute("data-modal");
    document.getElementById(modalId).style.display = "none";
  };
});

// Close modal if clicking outside of modal content
window.onclick = function(event) {
  modals.forEach(function(modal) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  });
};




	
//   header script

function closeDiv() {
	document.getElementById("Dropdown2").style.display = "none";
}

function openNav() {
	document.getElementById("mySidebar").style.width = "320px";
	document.getElementById("mySidebar").style.transition = "0.5s";
	document.getElementById("mySidebar").style.boxShadow = "0 0 0 10000px rgba(0,0,0,.75) ";
	document.getElementById("SidebarUl").style.opacity = "1";
	document.getElementById("SidebarUl").style.transition = "0.2s";
}
var abc;

function closeNav() {
	document.getElementById("mySidebar").style.width = "0";
	document.getElementById("mySidebar").style.boxShadow = "none ";
	document.getElementById("SidebarUl").style.opacity = "0 ";
	document.getElementById("SidebarUl").style.transition = "0.1s";
	var sd = document.getElementsByClassName("MobileNav2");
	for (let i = 0; i < sd.length; i++) {
		sd[i].style.width = "0";
		sd[i].style.left = "-100px";
	}

}

function OpenLi(clickedID) {
	var elementid = document.getElementById(clickedID);
	let str = clickedID;
	str = str.substring(1);
	// alert(str);
	// if ("NavItem1" == clickedID) {
	var Imgid = document.getElementById(str);
	Imgid.style.width = "320px";
	Imgid.style.left = "0";
	abc = Imgid;
	// }
}

function backtoNav() {
	var ccc = abc;
	ccc.style.width = "0";
	ccc.style.left = "-100px";

}





